var _rect, _path, _path2, _path3, _path4, _path5, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOperations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#F2BF7E"
    },
    points: "359.445,275.331 359.445,61.127 288.392,61.127 288.392,293.094 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.963,
    y: 100.582,
    style: {
      fill: "#FFFFFF"
    },
    width: 71.912,
    height: 47.942
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#F2BF7E"
    },
    points: "391.837,491.624 391.837,20.376 462.89,20.376 462.89,491.624 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.837,
    y: 60.635,
    style: {
      fill: "#FFFFFF"
    },
    width: 71.912,
    height: 47.942
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#E2804F"
    },
    points: "32.392,491.624 32.392,292.349 159.869,260.388 159.869,292.349 288.392,260.388  288.392,292.349 415.869,260.388 415.869,491.624 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 64.23,
    y: 340.292,
    style: {
      fill: "#FFFFFF"
    },
    width: 95.88,
    height: 31.961
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.09,
    y: 340.292,
    style: {
      fill: "#FFFFFF"
    },
    width: 95.88,
    height: 31.961
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 383.843,
    y: 452.159,
    style: {
      fill: "#F2BF7E"
    },
    width: 31.961,
    height: 39.946
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.273,
    y: 452.159,
    style: {
      fill: "#F2BF7E"
    },
    width: 239.71,
    height: 39.946
  })), /*#__PURE__*/React.createElement("rect", {
    x: 271.977,
    y: 412.202,
    style: {
      fill: "#D4E4AC"
    },
    width: 111.867,
    height: 47.942
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271.977,
    y: 460.142,
    style: {
      fill: "#FFFFFF"
    },
    width: 111.867,
    height: 31.961
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 483.265,
    width: 512,
    height: 15.673
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M383.478,13.061v239.282h15.673V116.506h56.424v359.445h15.673V13.061H383.478z M455.576,28.735v25.078h-56.424V28.735 H455.576z M399.151,100.833V69.486h56.424v31.347H399.151z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M280.033,243.984h15.673v-87.771h56.424v103.445h15.673V53.812h-87.771V243.984z M295.706,140.539v-32.392h56.424v32.392 H295.706z M352.131,69.486v22.988h-56.424V69.486H352.131z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M168.229,379.82H56.424V332.8h111.804V379.82z M72.098,364.147h80.457v-15.673H72.098V364.147z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M288.392,379.82H176.588V332.8h111.804V379.82z M192.261,364.147h80.457v-15.673h-80.457V364.147z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 343.771,
    y: 372.506,
    style: {
      fill: "#FFFFFF"
    },
    width: 48.065,
    height: 15.673
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M264.359,475.951h15.673v-7.314h96.131v7.314h15.673v-72.098H264.359V475.951z M280.033,452.963v-9.404h96.131v9.404 H280.033z M376.163,419.527v8.359h-96.131v-8.359H376.163z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "295.706,282.304 295.706,250.343 168.229,282.304 168.229,250.363 24.033,286.222 24.033,475.951 39.706,475.951  39.706,460.278 254.955,460.278 254.955,444.604 39.706,444.604 39.706,298.475 152.555,270.411 152.555,302.392 280.033,270.432  280.033,302.392 407.51,270.432 407.51,444.604 399.151,444.604 399.151,460.278 407.51,460.278 407.51,475.951 423.184,475.951  423.184,250.343 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperations);
export default __webpack_public_path__ + "static/media/operations.ec187d527f411a372e458b515c9a2962.svg";
export { ForwardRef as ReactComponent };